// Mirrors warehouseRefreshArgsSchema in packages/middleware/src/warehouse/
// warehouse-refresh.runner.ts — the task takes no args ({}).
export function validateWarehouseRefreshArgs(value: unknown): string | null {
  if (value === undefined || value === null) return null
  if (typeof value !== 'object' || Array.isArray(value) || Object.keys(value).length > 0) {
    return 'Warehouse Refresh takes no arguments'
  }
  return null
}
